import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { useMainStore } from '@/stores/main'
import * as LocalStorageService from '@/services/LocalStorageService'
import { i18n } from './i18n/settings'
import { Config } from './Config'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)

// Load from local storage (token, settings...)
const store = useMainStore()
LocalStorageService.loadState()

// Set language.
const selectedLanguage = store.currentLanguage.value
if (selectedLanguage){
  console.log("imposto da store")
  i18n.global.locale.value = selectedLanguage
} else {
  // If no language is set, use the browser's language or default to English.
  const browserLanguage = navigator.language || 'en'
  let langCode = browserLanguage.split('-')[0]
  const supportedLanguages = Object.keys(Config.languages)
  if (!supportedLanguages.includes(langCode)) {
    langCode = 'en'
  }
  i18n.global.locale.value = langCode
}

app.use(router)
app.use(i18n)
app.use(vuetify)

app.mount('#app')
